export async function pushDatalayer(datalayer = {}) {
    const datalayerData = {
        ...datalayer,
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(datalayerData);
}
